import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ApiNew from "./Api";
import PARSE from "html-react-parser";

const api = new ApiNew();

function SSoft_Home_About() {
  const activeLanguage = useSelector((state) => state.content.activeLanguage);
  const [sections, setSections] = useState([]);
  const [title, setTitle] = useState(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const getSectionDetail = () => {
      api
        .getSectionDetail({ language: activeLanguage })
        .then((res) => {
          if (res === 200 || res.data) {
            setSections(res.data.results);
          }
        })
        .catch((err) => {
          console.log("~ err", err);
        });
    };

    getSectionDetail();
  }, [activeLanguage]);

  useEffect(() => {
    let switchCaseCompleted = 0;

    if (sections.length > 0) {
      const sec = sections[0]?.widgets;
      if (sec && sec.length !== 0) {
        sec.forEach((section, i) => {
          switch (i) {
            case 0: {
              setTitle(section?.widget_contents[0]);
              break;
            }

            default:
              break;
          }

          switchCaseCompleted++;
        });

        if (switchCaseCompleted === 2) {
          setLoaded(true);
        }
      }
    }
  }, [sections]);

  return (
    <div className=" w-fudll bg-[#0F4C5C] py-[80px]  sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="section-container section-margin-x">
        <div className="max-w-3xl mx-auto text-center flex flex-col items-center space-y-[30px]">
          <h1 className="header-style-non-hero !text-white ">
            {title?.article_language?.title}
          </h1>

          <p className="content-subheader-style-non-hero !text-white max-w-4xl mx-auto ">
            {PARSE(title?.article_language?.content || "")}
          </p>
          <Link
            to={title?.article_language?.path || "/"}
            className="flex items-center justify-center h-[48px]  hd:px-[25px] fhd:text-[18px] text-[16px]  md:px-[17px] px-[8px] font-inter bg-[#e12726] rounded-[8px] text-white s:w-fit font-semibold leading-[20px] !mt-[50px]"
          >
            {title?.article_language?.summary}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default SSoft_Home_About;
